import Vue from 'vue';

import VTooltip from 'v-tooltip';
import Buefy from 'buefy';
import InfoTooltip from './components/Common/InfoTooltip.vue';
import AdrielInput from './components/Common/AdrielInput.vue';
import CheckBox from './components/Common/CheckBox.vue';
import {
    Dropdown,
    Menu,
    Modal,
    Tooltip,
    Input,
    Alert,
    Pagination,
    Form,
    Radio,
    Progress,
    Space,
} from 'ant-design-vue';
import moment from 'moment';
import momentDurationFormatSetup from 'moment-duration-format';

momentDurationFormatSetup(moment);

Vue.use(Buefy);
Vue.component('info-tooltip', InfoTooltip);
Vue.component('adriel-input', AdrielInput);
Vue.component('v-popover', VTooltip.VPopover);
Vue.component('check-box', CheckBox);

//AntD
Vue.use(Dropdown);
Vue.use(Menu);
Vue.use(Modal);
Vue.use(Tooltip);
Vue.use(Input);
Vue.use(Alert);
Vue.use(Pagination);
Vue.use(Form);
Vue.use(Radio);
Vue.use(Progress);
Vue.use(Space);
